import { getFullFieldPath } from '../../utils';

import { COMMUNICATION_TAB_KEY } from './constants';

export const getFullCommunicationPath = (fieldId) => getFullFieldPath(COMMUNICATION_TAB_KEY, fieldId);
